import { Box, Card, CardContent, Skeleton } from '@mui/material';

// Pre-computed arrays to avoid Array.from in JSX
const TIME_RANGE_ITEMS = [1, 2, 3];

const TimeRangeSkeletonItem = () => (
  <Skeleton variant="rounded" width={48} height={24} sx={{ borderRadius: 4, flexShrink: 0 }} />
);

export const GraphSkeleton = () => {
  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            mb: 2.5,
            flexWrap: 'wrap',
            overflowX: 'auto',
          }}
        >
          {TIME_RANGE_ITEMS.map((item) => (
            <TimeRangeSkeletonItem key={item} />
          ))}
        </Box>
        <Skeleton variant="rectangular" width="100%" height={240} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>
  );
};

export default GraphSkeleton;
